<template>
    <div class="error-page">
        <VStatusScreen
            tone="danger"
            :title="title"
            :message="message">
            <template #icon>
                <svg viewBox="0 0 24 24" fill="none">
                    <path d="M3 3l18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                    <path d="M7.6 8.1A5 5 0 0 0 7 18h9a4 4 0 0 0 2.6-7.05M9.7 5.6A5 5 0 0 1 17 9.2a4 4 0 0 1 1.9.5"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </template>
            <template #actions>
                <VButton variant="primary" gradient size="lg" full-width v-on:click.native="reload">
                    {{ $t('reload') }}
                </VButton>
            </template>
        </VStatusScreen>
    </div>
</template>

<script>
import VStatusScreen from "@/components/ui/VStatusScreen.vue";
import VButton from "@/components/ui/VButton.vue";

export default {
    name: "ErrorScreen",
    components: { VStatusScreen, VButton },
    computed: {
        params() {
            return this.$route.params || {};
        },
        title() {
            return this.params.errorTitle || this.$t('Error loading');
        },
        message() {
            return this.params.errorMessage
                || this.$t('We were unable to load the menu, refresh the page or scan the QR code again');
        },
    },
    methods: {
        reload() {
            window.location.reload();
        },
    },
};
</script>

<style lang="scss" scoped>
.error-page {
    /* viewport units, not %: the document scrolls, ancestor heights are content-driven */
    min-height: 100vh;
    min-height: 100svh;
    background: var(--surface-page);
}
</style>
